/**
 * Customer-app token map (capsico-customer-app-ui §1). Same NAMES as the Refyll customer
 * standard so inherited patterns read 1:1; Capsico VALUES. Screens style through the Tailwind
 * theme in index.css — these raw values are only for canvas / map code that cannot use classes.
 */
export const BRAND_050 = '#FFF6DB';
export const BRAND_100 = '#FFEDB8';
export const BRAND_500 = '#F7B614';
export const BRAND_600 = '#E5A50C';
/** Solid CTA fill — always with INK text, never white. */
export const BRAND_700 = '#F7B614';
/** Links and brand-coloured text (yellow text is never allowed). */
export const BRAND_800 = '#8A5A00';
export const INK = '#1F1F1F';
export const INK_2 = '#5C5F66';
export const INK_3 = '#8B8F96';
export const HAIR = '#E9EBEF';
export const TILE_BG = '#F4F5F7';
export const GREEN = '#1BA672';
export const RED = '#D93A3A';
export const AMBER = '#C77A0A';
